import { render, staticRenderFns } from "./JewelryList.vue?vue&type=template&id=2886b7ed&scoped=true"
import script from "./JewelryList.vue?vue&type=script&lang=js"
export * from "./JewelryList.vue?vue&type=script&lang=js"
import style0 from "./JewelryList.vue?vue&type=style&index=0&id=2886b7ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886b7ed",
  null
  
)

export default component.exports